import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ActivityItem, ActivityItemClick } from '../../planning.types';
import { ActivityBlockComponent } from '../activity-block/activity-block.component';

@Component({
  selector: 'app-activity-cell',
  standalone: true,
  template: `
    <div class="activity-cell">
      @for (item of items(); track item.id) {
        <app-activity-block
          [item]="item"
          [active]="item.id === activeId()"
          (blockClick)="itemClick.emit($event)" />
      }
      @if (isBlastDate()) {
        <span class="activity-cell__blast-dot" role="img" aria-label="Blast date"></span>
      }
    </div>
  `,
  styles: [`
    :host { display: block; width: 100%; height: 100%; }
    .activity-cell {
      position:        relative;
      display:         flex;
      flex-direction:  column;
      justify-content: center;
      gap:             var(--block-gap, 0.25rem);
      width:           100%;
      height:          100%;
      min-height:      var(--row-height, 2.75rem);
      padding:         0.25rem 0.1875rem;
      box-sizing:      border-box;
    }
    .activity-cell__blast-dot {
      position:       absolute;
      top:            50%;
      left:           50%;
      transform:      translate(-50%, -50%);
      width:          0.75rem;
      height:         0.75rem;
      border-radius:  50%;
      background:     var(--blast-date-color, #e54b4b);
      box-shadow:     0 0 0 2px var(--c-white, #fff);
      pointer-events: none;
      z-index:        2;
    }
  `],
  imports: [ActivityBlockComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCellComponent {
  readonly items       = input.required<ActivityItem[]>();
  readonly activeId    = input<string | null>(null);
  readonly isBlastDate = input<boolean>(false);

  readonly itemClick = output<ActivityItemClick>();
}
